module.exports = __webpack_public_path__ + "components/country-flag/static/np-d85a9cb7fc8cebd816ddeb88c621898a.svg";